module.exports = __webpack_public_path__ + "static/media/opensea.c7c3ed10.svg";